module.exports = __webpack_public_path__ + "static/media/103.efdbb96f.png";